import { type TGlobalFunctionTyped } from '../../../common/hooks/useTranslation';
import { type SpendingType } from '../models/breakdownSpending';

export const getSpendingTypeName = (
  spendingType: SpendingType,
  translator: TGlobalFunctionTyped,
): string => {
  switch (spendingType) {
    case 'expenseClaim':
      return translator('budget.breakdownSpendings.spendingType.expenseClaim');
    case 'invoice':
      return translator('budget.breakdownSpendings.spendingType.invoice');
    case 'subscription':
      return translator('budget.breakdownSpendings.spendingType.subscription');
    case 'virtualCard':
      return translator('budget.breakdownSpendings.spendingType.virtualCard');
    case 'physicalCard':
      return translator('budget.breakdownSpendings.spendingType.physicalCard');
    case 'purchaseOrder':
      return translator('budget.breakdownSpendings.spendingType.purchaseOrder');
    default:
      throw new Error('No spending type for the spending type key');
  }
};
